import {getCaseDetailModule,
  getCaseDetailModuleData,
  getCaseDetailModuleJSON,
  getMsgConfigByActId,
  queryLatestFieldByActId,
  saveOrUpdateDynamicform,
  queryFormRelationList,
  queryAllPublishFormRelations} from '@/assets/js/api';
import Vue from 'vue';
import {amount_format_yuan} from '@/assets/js/utils';
import {decrypt} from '@/assets/js/tool';
import CryptoJS from 'crypto-js';
import {YS_FILE_TYPE_CODE} from '../../assets/js/constant';

const SUCCESS = 200;

function formatData(data, moneyKeys) {
  Object.keys(data)
    .forEach(key => {
      if (moneyKeys.includes(key)) {
        data[key] = amount_format_yuan(data[key]);
      }
    });
  // 自定义数据处理
  const extendFields = data.extendFields || {};
  Object.keys(extendFields)
    .forEach(key => {
      data[`extendFields&${key}`] = moneyKeys.includes(`extendFields&${key}`) ? amount_format_yuan(extendFields[key]) : extendFields[key];
    });
}
function getMoneyKeys(state) {
  const moneyKeys = [];
  Object.keys(state.formSchema).forEach(key => {
    const {formItems} = state.formSchema[key];
    formItems.map(item => {
      if (item.directive === 'input-money') {
        moneyKeys.push(item.key);
      }
    });
  });
  return moneyKeys;
}
export default {
  state: {
    formRuleConfig: {},
    formSchema: {},
    formData: {},
    latestField: {},
    // 被申请人代理人
    respondentAgentFormItems: [
      {
        label: '代理权限',
        is: 'el-select',
        key: 'agtPermission',
        prop: 'agtPermission',
        clearable: false,
        childEl: 'codeType_8035'
      },
      {
        label: '姓名',
        is: 'el-input',
        key: 'agtName',
        prop: 'agtName',
        maxlength: 50
      },
      {
        label: '身份证号',
        is: 'el-input',
        key: 'agtIdNumber',
        prop: 'agtIdNumber',
        maxlength: 18
      },
      {
        label: '手机号',
        is: 'el-input',
        key: 'agtPhone',
        prop: 'agtPhone',
        maxlength: 11
      },
      {
        label: '单位电话',
        is: 'el-input',
        key: 'agtUnitContactInfo',
        prop: 'agtUnitContactInfo',
        maxlength: 50
      },
      {
        label: '电子送达邮箱',
        is: 'el-input',
        key: 'agtMail',
        prop: 'agtMail',
        maxlength: 50
      },
      {
        label: '送达地址',
        is: 'el-input',
        key: 'agtDeliveryAddress',
        prop: 'agtDeliveryAddress',
        maxlength: 50
      },
      {
        label: '代理人类型',
        is: 'el-select',
        key: 'agtType',
        prop: 'agtType',
        childEl: 'codeType_11150173'
      },
      {
        label: '律师执业类别',
        is: 'el-select',
        key: 'agtLawyerType',
        prop: 'agtLawyerType',
        childEl: 'codeType_11401845',
        customShow: 'customShow'
      },
      {
        label: '所在律所',
        is: 'el-input',
        key: 'agtOffice',
        prop: 'agtOffice',
        maxlength: 50,
        customShow: 'customShow'
      },
      {
        label: '律所注册地',
        is: 'el-input',
        key: 'lawRegistrAddress',
        prop: 'lawRegistrAddress',
        maxlength: 50,
        customShow: 'customShow'
      },
      {
        label: '执业证号',
        is: 'el-input',
        key: 'agtLicnumber',
        prop: 'agtLicnumber',
        maxlength: 25,
        customShow: 'customShow'
      },
    ],
    moneyKeys: [],
    dataTree2: [],
    ayList: [],
    ayLists: [],
    callDetail: [],
    callDetails: [],
  },
  getters: {},
  mutations: {
    Set_Form_Rule(state, ruleConfig) {
      state.formRuleConfig = ruleConfig || {};
    },
    // 存储要素列表
    SET_YS_LISTS(state, data) {
      state.ayLists = data;
    },
    // 存储外呼详情
    SET_YS_WH_DETAILS(state, data) {
      state.callDetails = data;
    },
    // 存储表单模型
    SET_FORM_MODULE(state, _data) {
      Object.keys(_data)
        .forEach(key => {
          if (key === 'dataTree2') {
            Vue.set(state, 'dataTree2', _data[key].tree);
            Vue.set(state, 'ayList', _data[key].ayList);
            Vue.set(state, 'callDetail', _data[key].callDetail);
          } else {
            Vue.set(state.formSchema, `${key}`, _data[key]);
          }
        });
    },
    // 存储数据模型
    SET_FORM_MODULE_DATA(state, _data) {
      const moneyKeys = getMoneyKeys(state);
      Vue.set(state, 'moneyKeys', moneyKeys);
      Object.keys(_data)
        .forEach(key => {
          const data = _data[key];
          if (Array.isArray(data)) {
            data.forEach(item => {
              // 处理数据
              formatData(item, moneyKeys);
            });
          } else {
            // 处理数据
            formatData(data, moneyKeys);
          }
          Vue.set(state.formData, `${key}`, data);
        });
    },

    SET_LATEST_FIELD(state, _data) {
      Object.keys(_data)
        .forEach(key => {
          const data = _data[key].reduce((result, item) => {
            const {
              regx, fieldName, extendFields = [], desc = []
            } = item;
            if (desc) {
              result[fieldName] = {
                desc,
                regx,
              };
            }
            if (fieldName === 'extendFields') {
              extendFields.forEach(extendField => {
                const {
                  regx, fieldName, desc, customValidator, trigger
                } = extendField;
                if (desc) {
                  result[`extendFields&${fieldName}`] = {
                    desc,
                    trigger,
                    regx,
                    customValidator: customValidator ? eval(customValidator) : ''
                  };
                }
              });
            }
            return result;
          }, {});
          Vue.set(state.latestField, `${key}`, data);
        });
    },

  },
  actions: {

    /**
     * @description 获取表单验证规则配置
     * @param {function} commit commit
     * @param {string} actId 调解机构ID
     * @constructor
     */
    async GetFormRule({commit}, actId) {
      await getMsgConfigByActId({actId})
        .then(({
          code, data
        }) => {
          if (code === SUCCESS) {
            commit('Set_Form_Rule', data);
          }
        });
    },

    /**
     * @description 存储表单模型
     * @constructor
     */
    async SetFormModule() {
      const res = await getCaseDetailModuleJSON();
      if (res.code === SUCCESS) {
        await saveOrUpdateDynamicform({
          configType: 'case-detail',
          jsonValue: res.data.jsonValue
        });
      }
    },

    /**
     * @description 获取表单模型
     * @param {function} commit commit
     * @constructor
     */
    async GetFormModule({commit}) {
      await getCaseDetailModule({configType: 'case-detail'})
        .then(({
          code, data, msg
        }) => {
          if (code === SUCCESS && data) {
            const formSchema = data.jsonValue;
            commit('SET_FORM_MODULE', formSchema);
          } else {
            Vue.prototype.$message.error(msg);
          }
        });
    },

    /**
     * @description 获取表单数据
     * @param {function} commit commit
     * @constructor
     */
    async GetFormModuleData({commit}) {
      await getCaseDetailModuleData()
        .then(({
          code, data
        }) => {
          if (code === SUCCESS) {
            commit('SET_FORM_MODULE_DATA', data);
          }
        });
    },

    /**
     * @description 获取表单模型
     * @param {function} commit commit
     * @param {string} actId actId
     * @constructor
     */
    async GetLatestField({commit}, params) {
      await queryLatestFieldByActId(params)
        .then(({
          code, data, msg
        }) => {
          if (code === SUCCESS && data) {
            const decryptResult = decryptJSON(data);
            if (decryptResult) {
              console.log('decryptResult', decryptResult);
              commit('SET_LATEST_FIELD', decryptResult);
            } else {
              Vue.prototype.$message.error('格式错误');
            }
          } else {
            Vue.prototype.$message.error(msg);
          }
        });
    },

    /**
     * @description 获取要素配置信息
     * @param {function} commit commit
     * @param actId
     * @constructor
     */
    async GetYsConfigInfo({commit}, actId) {
      await queryFormRelationList({actId})
        .then(({
          code, data, msg
        }) => {
          if (code === SUCCESS && data) {
            const callDetail = {};
            const list = data.sort((a, b) => a.sort - b.sort).map(item => {
              callDetail[item.caseReason] = item.otherConfig ? JSON.parse(item.otherConfig) : [];
              const exclusiveFileTypes = item.exclusiveFileTypes ? item.exclusiveFileTypes.split(',') : [];
              return {
                formId: item.formId,
                dataKey: item.dataKey,
                code: item.caseReason,
                loop: item.isLoop || false,
                evidenceFileType: YS_FILE_TYPE_CODE.filter(item => !exclusiveFileTypes.includes(item)),
                name: item.shortName,
                type: item.shortElementFieldName,
                key: item.elementFieldName,
              };
            });
            // 存储要素列表
            commit('SET_YS_LISTS', list);
            // 存储要素对应的外呼配置表单项
            commit('SET_YS_WH_DETAILS', callDetail);
          } else {
            Vue.prototype.$message.error(msg);
          }
        });
    },

    /**
     * @description 获取要素配置信息
     * @param {function} commit commit
     * @param actId
     * @constructor
     */
    async GetAllYsConfigInfo({commit}, actId) {
      await queryAllPublishFormRelations({actId})
        .then(({
          code, data, msg
        }) => {
          if (code === SUCCESS && data) {
            const callDetail = {};
            const list = data.sort((a, b) => a.sort - b.sort).map(item => {
              callDetail[item.caseReason] = item.otherConfig ? JSON.parse(item.otherConfig) : [];
              const exclusiveFileTypes = item.exclusiveFileTypes ? item.exclusiveFileTypes.split(',') : [];
              return {
                formId: item.formId,
                dataKey: item.dataKey,
                code: item.caseReason,
                loop: item.isLoop || false,
                evidenceFileType: YS_FILE_TYPE_CODE.filter(item => !exclusiveFileTypes.includes(item)),
                name: item.shortName,
                type: item.shortElementFieldName,
                key: item.elementFieldName,
              };
            });
            // 存储要素列表
            commit('SET_YS_LISTS', list);
            // 存储要素对应的外呼配置表单项
            commit('SET_YS_WH_DETAILS', callDetail);
          } else {
            Vue.prototype.$message.error(msg);
          }
        });
    },
  }
};

function decryptJSON({
  dynamicFieldStr, encryptStr, publicKey
}) {
  const MD5 = CryptoJS.MD5(dynamicFieldStr).toString();
  const decryptResult = decrypt(encryptStr, publicKey);
  return decryptResult === MD5 ? JSON.parse(dynamicFieldStr) : false;
}
